// @ts-nocheck

import React, { useLayoutEffect, useRef, useState } from 'react';
import styled, { css, keyframes } from 'styled-components';

const MarqueeContainer = styled.div`
  display: flex;
  overflow-x: scroll;
  width: 100%;
  margin-right: 0.3em;

  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;

const MarqueeLikeAnimation = keyframes`
  0% {
    transform: translateX(-2em);
  }
  25% {
    transform: translateX(-2em);
  }
  100% {
    transform: translateX(calc(-100% - 2em));
  }
`;

const MarqueeContent = styled.div`
  ${({ $animate }) =>
    $animate
      ? css`
          padding-left: 2em;
          animation: ${MarqueeLikeAnimation} 10s linear infinite;
        `
      : undefined}
`;

type CustomMarkeePropsType = {
  children: React.ReactNode;
};

const Marquee = ({ children }: CustomMarkeePropsType) => {
  const [isOverflowing, setIsOverflowing] = useState(false);

  const containerRef = useRef();
  const contentRef = useRef();

  useLayoutEffect(() => {
    const contentElement = contentRef?.current;
    const containerElement = containerRef?.current;

    if (contentElement && containerElement) {
      const trigger = () => {
        const hasOverflow = contentElement.clientWidth > containerElement.clientWidth;

        setIsOverflowing(hasOverflow);
      };

      window.addEventListener('resize', trigger);

      trigger();

      return () => {
        window.removeEventListener('resize', trigger);
      };
    }
  }, [contentRef, containerRef]);

  return (
    <MarqueeContainer ref={containerRef}>
      <MarqueeContent ref={contentRef} $animate={isOverflowing}>
        {children}
      </MarqueeContent>
      {isOverflowing ? <MarqueeContent $animate={isOverflowing}>{children}</MarqueeContent> : null}
    </MarqueeContainer>
  );
};

export default Marquee;
